export default __webpack_public_path__ + "static/media/icon-support-chat.3bdeecb4.svg";